<template>
    <b-table class="table-responsive-lg w-100"  :items="items" :tbody-tr-class="rowClass" :fields="fields">
        <template v-slot:cell(mes)="data">
            <span v-html="data.value"></span>
        </template>
        
        <template v-slot:cell(small_fio)="data">
            <div v-html="data.value"></div>
            <small>{{data.item.email}}</small>
        </template>
    </b-table>
</template>

<script>
export default {
    name: "tab_monitoring",
    
    created() {
        this.getItems();
        EventBus.$on('refresh_tabs', e => {
            this.refresh_tab(e);
        });
    },
    
    props: {
        doc_id: {
            type: Number,
            required: true
        },
    },
    
    data() {
        return {
            items: [],
            fields: [
                {
                    key: 'id',
                    label: 'ID',
                },
                
                {
                    key: 'small_fio',
                    label: 'ПIБ',
                },
                
                {
                    key: 'mes',
                    label: 'Комент',
                },
                
                {
                    key: 'action_h_name',
                    label: 'Дiя',
                },
                {
                    key: 'formated_added',
                    label: 'Дата',
                },
            ],
            
            
        }
    },
    
    methods: {
        
        show_loading(flag) {
            this.$store.dispatch('memorandum_work_tabs/SET_MEM_LOAD_TAB', {
                type: this.$options.name,
                active: flag
            });
        },
        
        refresh_tab (e) {
            if(e.tabs.length > 0) {
                let self = this;
                e.tabs.forEach(tab => {
                    if(tab === this.$options.name) {
                        self.getItems();
                    }
                })
            }
        },
        
        async getItems() {
            this.show_loading(true);
            api.get('/memorandums/'+ this.doc_id +'/history').then(({data}) => {
                if (data.status === "operation_success") {
                    this.items = data.data;
                    this.show_loading(false);
                }
            }).catch(err => {
                this.show_loading(false);
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        rowClass(item) {
            if (!item) return
            if (item.class === 'info') return 'table-info'
            if (item.class === 'success') return 'table-success'
            if (item.class === 'error') return 'table-danger'
            if (item.class === 'hidden') return 'd-none'
        }
    },
    
}
</script>

<style scoped>

</style>
